module.exports = "<mat-select class=\"lang-select\" (change)=\"langChange($event.value)\" [(value)]=\"selected\" >\n        <mat-option  value=\"lt\">LT</mat-option>\n        <mat-option  value=\"en\">EN</mat-option>\n    </mat-select>\n<c-head> </c-head>\n<router-outlet></router-outlet>\n<c-footer> </c-footer>\n<button onclick=\"topNew()\" id=\"myBtn\" >\n    <mat-icon>expand_less</mat-icon>\n\n    <!-- <i class=\"material-icons md-36\">keyboard_arrow_up</i> -->\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main